import { useEffect, useState } from "react";
import { listCurriculumBoards } from "@/lib/api";

const COLORS = {
  "AQA GCSE":     "bg-[#9DFFB0] dark:bg-[#68D391]",
  "Edexcel GCSE": "bg-[#90E0FF] dark:bg-[#63B3ED]",
  "OCR GCSE":     "bg-[#FFB38E] dark:bg-[#F6AD55]",
};

/**
 * Compact 3-tile exam board picker. Default boards array is loaded from
 * the API so we never hard-code the list of supported boards twice.
 */
export default function BoardPicker({ value, onChange, testIdPrefix = "board" }) {
  const [boards, setBoards] = useState([]);

  useEffect(() => {
    listCurriculumBoards()
      .then(setBoards)
      .catch(() => setBoards([{ board: "AQA GCSE", total_topics: 20 }]));
  }, []);

  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testIdPrefix}-grid`}>
      {boards.map((b) => {
        const active = value === b.board;
        return (
          <button
            key={b.board}
            type="button"
            data-testid={`${testIdPrefix}-${b.board.split(" ")[0].toLowerCase()}`}
            onClick={() => onChange(b.board)}
            className={`nb-border rounded-xl px-3 py-3 text-left font-bold transition-all ${
              active ? `${COLORS[b.board] || "bg-[#D4C4FB]"} nb-shadow text-black` : "bg-white dark:bg-zinc-900"
            }`}
          >
            <div className="font-display text-base font-extrabold leading-tight">
              {b.board.replace(" GCSE", "")}
            </div>
            <div className="text-[10px] font-bold opacity-70 mt-0.5">
              {b.total_topics ?? ","} topics
            </div>
          </button>
        );
      })}
    </div>
  );
}
